import { decode } from "jsonwebtoken";
/**
 * Decode JWT and return an additional `expired` flag so we can regenerate the session.
 */ function getJwtPayload(jwt, expireBeforeDays) {
    if (expireBeforeDays === void 0) expireBeforeDays = 16;
    const decoded = decode(jwt);
    const isValidUntil = new Date(decoded.validUntil);
    const expiresIn = isValidUntil.getTime() - 1000 * 60 * 60 * 24 * expireBeforeDays;
    return {
        ...decoded,
        isValidUntil,
        expired: new Date().getTime() >= expiresIn
    };
}
export { getJwtPayload };
